import {
  Box,
  Button,
  Stack,
  styled,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import ButtonCircle from 'src/components/ButtonCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TryOutlinedIcon from '@mui/icons-material/TryOutlined';
import { colors } from 'src/theme/schemes/PureLightTheme';
import PopulatingDataProgressV2 from 'src/components/Retail/PopulatingDataProgressV2';
import Activity from '../../../layouts/SidebarLayout/Header/Top/component/Activity';
import useRefreshObjectList from 'src/hooks/useRefreshObjectList';
import { reducerUpdateOpenAIAssistant } from 'src/features/AIAssistantPosition';
import { toogleSidebar } from 'src/features/sidebarToggleSlice';
import { useLocation, useNavigate } from 'react-router';
import useObjectManagement from 'src/services/useObjectManagement';
import moment from 'moment';

interface ICustomBox {
  isOnTour: boolean;
}

const CustomBox = styled(Box)<ICustomBox>(
  ({ theme, isOnTour }) => `
    max-width: 100vw;
    padding: ${theme.spacing(2, 4)};
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ${!isOnTour && 'z-index: 6;'}
    overflow: hidden;
    background: #fff;
`
);

const TopHeaderV2 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const { isOnTour } = useAppSelector((state) => state.storeProductTour);
  const refreshObjectList = useRefreshObjectList();
  const project = useAppSelector((state) => state.users.project);

  const { pathname } = useLocation();

  const { useGetLastUpdatedData } = useObjectManagement();

  const { data: lastUpdatedData } = useGetLastUpdatedData({
    variables: { projectId: project.id },
    skip: !project.id
  });

  const getPagePath = (pathname: string) => {
    const paths = pathname.split('/');
    const cleanedPaths = paths.slice(1, 3).map(
      (
        path // capitalize and replace _ with space
      ) =>
        path.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
    );
    const pathWithSeparator = cleanedPaths.join(' > ');
    return pathWithSeparator;
  };

  const title = getPagePath(pathname);

  const { isOpen: isAIAssistantOpen } = useAppSelector(
    (state) => state.storeAIAssistantPosition
  );
  const sidebarToggle = useAppSelector((state) => state.sidebarToggle.toggle);

  const handleOpenAIAssistant = () => {
    dispatch(reducerUpdateOpenAIAssistant(!isAIAssistantOpen));
    dispatch(toogleSidebar(!sidebarToggle));
  };

  const handleRefresh = () => {
    refreshObjectList();
    // if (title === 'sna') dispatch(reducerUpdatePrun(prunLocal));
  };

  return (
    <CustomBox sx={{ ...(!matchesUpMd && { padding: 1 }) }} isOnTour={isOnTour}>
      <Typography>{title}</Typography>
      <PopulatingDataProgressV2 />
      <Stack direction="row" alignItems="center" spacing={2}>
        <Stack gap={0.5} alignItems="center">
          <Typography variant="caption">Last updated:</Typography>
          <Typography fontSize={14} variant="body1">
            {lastUpdatedData?.objectManagement_getLastDataUpdate
              ? moment(
                  lastUpdatedData.objectManagement_getLastDataUpdate
                ).format('DD MMM YYYY, HH:mm')
              : '-'}
          </Typography>
        </Stack>
        <ButtonCircle sx={{ background: '#F5F5F5' }} onClick={handleRefresh}>
          <Tooltip arrow title="Refresh">
            <RefreshIcon sx={{ color: '#285771' }} />
          </Tooltip>
        </ButtonCircle>
        <ButtonCircle
          sx={{ background: '#F5F5F5' }}
          onClick={() => navigate('/guide/video_tutorial')}
        >
          <Tooltip arrow title="Help">
            <HelpOutlineIcon sx={{ color: '#285771' }} />
          </Tooltip>
        </ButtonCircle>
        <Activity variant="circle" />
        <Button
          variant="contained"
          startIcon={<TryOutlinedIcon sx={{ fontSize: '16px !important' }} />}
          sx={{ background: colors.gradients.purple1, fontWeight: 600 }}
          onClick={handleOpenAIAssistant}
        >
          AI Assistant
        </Button>
      </Stack>
    </CustomBox>
  );
};

export default TopHeaderV2;
